import React, { FormEvent, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { LoginSteps } from '../Login'
import useAssociate from 'src/hooks/useAssociate'
import { AssociateError } from 'src/util/associate'
import Loading from 'src/components/Loading/Loading'

type Status = Extract<LoginSteps, 'missing-secret' | 'invalid-secret'>

const fields: Record<Status, {title: string, description: string}> = {
  'missing-secret': {
    description: 'login.remind',
    title: 'login.see-email'
  },
  'invalid-secret': {
    description: 'login.re-pair-client-info',
    title: 'login.re-pair-client-no-association'
  }
}

interface SecretProps {
  handleStatus: (step: LoginSteps) => void
  status: Status
  userId: string | null
}

export default function Secret ({
  handleStatus,
  status,
  userId
}: SecretProps) {

  const [code, setCode] = useState<string>('')
  const [associateError, setAssociateError] = useState<boolean>(false)
  const [otherError, setOtherError] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const { associateUser } = useAssociate()
  const intl = useIntl()

  const handleContinue = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    try {
      setLoading(true)
      await associateUser(userId, code)
    } catch (err) {
      setLoading(false)
      if (err instanceof AssociateError) {
        setAssociateError(true)
      } else {
        setOtherError(true)
        console.warn(err)
      }
    }
  }

  if (loading) return <Loading />

  return (
    <form onSubmit={handleContinue}>
      <p className="secret-title">
        <FormattedMessage id={fields[status].title} />
      </p>
      <label className="code">
        <span className="icon icon-lock" />
        <input
          required
          type="text"
          placeholder={intl.formatMessage({ id: 'code' })}
          value={code}
          onChange={({ target }) => setCode(target.value)}
        />
      </label>
      {!associateError && !otherError
        ? (
          <p className="remind">
            <FormattedMessage id={fields[status].description} />
          </p>
          )
        : null}
      {associateError
        ? (
          <p className="error-description">
            <FormattedMessage id="two-factor.code" />
          </p>
          )
        : null}
      {otherError
        ? (
            <p className="error-description">
              <FormattedMessage id="two-factor.code-error" />
            </p>
          )
        : null}
      <button className="filled" type="submit" disabled={code === ''}>
        <FormattedMessage id="continue" />
      </button>
      <span className="back" onClick={() => handleStatus('idle')} role="button">
        <FormattedMessage id="comeback" />
      </span>
    </form>
  )
}
